import { React, useRef, useState } from "react";
import PropTypes from "prop-types";
import Transcript from "./transcript";
import AudioPlayer from "react-h5-audio-player";
import "./audio-player.scss";
import "./player.scss";
import ReactPlayer from "react-player";
import SpeedButton from "./speedbutton";
import { ChatIcon } from "@/icons";
const mediaTypes = {
  audio: "auido",
  video: "video",
};
const MediaPlayer = ({ url, type, transcript, title, footer }) => {
  const [showTranscript, setShowTranscript] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [playing, setPlaying] = useState(true);
  const [currentTime, setCurrentTime] = useState();

  const audioRef = useRef(null);
  const videoRef = useRef(null);
  const seek = (startSecs, endSecs) => {
    if (type === mediaTypes.audio) {
      audioRef.current.audio.current.currentTime = startSecs;
      audioRef.current.audio.current.play();
      setTimeout(
        () => {
          audioRef.current.audio.current.pause();
        },
        (endSecs - startSecs) * 1000
      );
    }
    if (type === mediaTypes.video) {
      videoRef.current.seekTo(startSecs);
      setPlaying(true);
      setTimeout(
        () => {
          setPlaying(false);
        },
        (endSecs - startSecs) * 1000
      );
    }
  };
  const changeSpeed = (speed) => {
    setPlaybackRate(speed);
    if (type === mediaTypes.audio) {
      audioRef.current.audio.current.playbackRate = speed;
    }
  };
  const onListen = () => {
    try {
      const currentAudio = audioRef.current?.audio?.current;
      if (currentAudio) {
        setCurrentTime(currentAudio.currentTime);
      }
    } catch (e) {
      console.error(e);
    }
  };
  const renderAudioPlayer = () => {
    return (
      <>
        <AudioPlayer
          autoPlay
          width
          src={url}
          ref={audioRef}
          header={title}
          footer={footer}
          onListen={onListen}
          customAdditionalControls={["loop"]}
        />
      </>
    );
  };
  const renderVideoPlayer = () => {
    return (
      <div>
        <ReactPlayer
          controls
          url={url}
          ref={videoRef}
          playbackRate={playbackRate}
          playing={playing}
          className="video-player"
          onProgress={(e) => setCurrentTime(e.playedSeconds)}
          config={{
            file: {
              attributes: {
                crossOrigin: "true",
                controlsList: "nodownload",
              },
              tracks: [
                {
                  kind: "subtitles",
                  src: transcript,
                  srcLang: "default",
                  default: true,
                },
              ],
            },
          }}
        />
      </div>
    );
  };

  return (
    <div className="media-player">
      {type === mediaTypes.audio && renderAudioPlayer()}
      {type === mediaTypes.video && renderVideoPlayer()}
      <div className="flex justify-content-center margin-top-10">
        <SpeedButton
          speed={0.5}
          playbackRate={playbackRate}
          changeSpeed={changeSpeed}
        ></SpeedButton>
        <SpeedButton
          speed={1}
          playbackRate={playbackRate}
          changeSpeed={changeSpeed}
        ></SpeedButton>
        <SpeedButton
          speed={1.5}
          playbackRate={playbackRate}
          changeSpeed={changeSpeed}
        ></SpeedButton>
        <SpeedButton
          speed={2}
          playbackRate={playbackRate}
          changeSpeed={changeSpeed}
        ></SpeedButton>

        {transcript && (
          <button
            onClick={() => setShowTranscript((prevState) => !prevState)}
            outline
            size="sm"
            className={`plyr-btn obro-btn ${showTranscript ? "active" : ""}`}
          >
            <ChatIcon />
          </button>
        )}
      </div>
      {showTranscript && (
        <div className="tracks">
          <Transcript
            transcript={transcript}
            seek={seek}
            currentTime={currentTime}
          />
        </div>
      )}
    </div>
  );
};

MediaPlayer.propTypes = {
  url: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  transcript: PropTypes.string,
  metadata: PropTypes.string,
  title: PropTypes.string,
  footer: PropTypes.string,
};

export { mediaTypes };

export default MediaPlayer;
